export const DateOfBirthFieldData = {
  formControlName: 'dateOfBirth',
  id: 'grit-field-date-of-birth',
  type: 'tel',
  label: 'Date of birth',
  placeholder: 'MM/DD/YYYY',
  mask: 'date',
  prefixIcon: {
    iconName: 'cake',
  },
  validationList: [
    {
      errorKey: 'invalidMonth',
      message: 'The month you entered is invalid.',
    },
    {
      errorKey: 'invalidDayForMonth',
      message: 'The day you entered is invalid for the entered month.',
    },
    {
      errorKey: 'atLeastAge',
      args: ['18'],
      message: 'You must be at least 18 years old to apply or a lease.',
    },
    {
      errorKey: 'atMostAge',
      args: ['100'],
      message: 'You must be under 100 years old to apply for a lease.',
    },
  ],
  requiredMessage: 'Your date of birth is required to process the application.',
};
